var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex col",
    class: `col-${_vm.cols}`
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "label": _vm.label,
      "items": _vm.situacoes,
      "item-text": 'descricao',
      "item-value": 'id',
      "rules": _vm.required ? [function (v) {
        return _vm.$required(v);
      }] : []
    },
    model: {
      value: _vm.value.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.value, "situacao", $$v);
      },
      expression: "value.situacao"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }